import { textFilter } from "react-bootstrap-table2-filter";
import {
  ConvertMinutesToTimeRemain,
  CreateTooltip,
  DicomStatusHeader,
  Gender,
  getCellStyle,
  GetHeaderStyle,
  GetImageStduyStatus,
  UrgentType,
} from "../../core/Helper";
import { GetThaiDateTimeCheckToday } from "../../core/ThaiDate";
import { AiFillClockCircle } from "react-icons/ai";

const formatStatus = (cell, row) => {
  return <GetImageStduyStatus id={row.action_id} />;
};

const calRemainTime = (cell, row) =>
  ConvertMinutesToTimeRemain(row.remaining_time);
const customTextFilter = {
  placeholder: "...",
};
export const GetRadiWorkListColumn = (isNormal) =>
  new Promise((resolve, reject) => {
    resolve(getCol());
  });

const getCol = () => {
  const fontName = "tahoma";
  const fontSize = "14px";
  const dateSize = "14px";
  let cols = [
    {
      dataField: "action_dt",
      text: "วันที่ส่ง",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: () =>
        getCellStyle(
          "center",
          "var(--date-sent)",
          dateSize,
          fontName,
          "1px solid var(--date-border)"
        ),
      filter: textFilter(customTextFilter),
      formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    },

    {
      dataField: "result_expected",
      text: "นัดรับผล",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: getCellStyle(
        "center",
        "var(--date-appoint)",
        dateSize,
        fontName,
        "1px solid var(--date-border)"
      ),
      filter: textFilter(customTextFilter),
      formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    },
    {
      dataField: "radi_received_time",
      text: "รับเคส",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: getCellStyle(
        "center",
        "var(--date-accepted)",
        dateSize,
        fontName,
        "1px solid var(--date-border)"
      ),
      filter: textFilter(customTextFilter),
      formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    },
    {
      dataField: "remaining_time",
      text: CreateTooltip("เวลาคงเหลือ", <AiFillClockCircle />),
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: getCellStyle(
        "center",
        "var(--date-remaining)",
        dateSize,
        fontName,
        "1px solid var(--date-border)"
      ),
      filter: textFilter(customTextFilter),
      formatter: calRemainTime,
    },
    {
      dataField: "patientid",
      text: "HN",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: () => getCellStyle("center", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "patients_name",
      text: "ชื่อ-สกุล ผู้ป่วย",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "patients_sex",
      text: "เพศ",
      sort: true,
      headerStyle: () => GetHeaderStyle("50px"),
      style: () => getCellStyle("center", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
      formatter: Gender,
    },
    {
      dataField: "modality",
      text: "Modality",
      sort: true,
      headerStyle: () => GetHeaderStyle("80px"),
      style: () => getCellStyle("center", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "part",
      text: "Part",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "brchshort",
      text: "ส่งจาก รพ.",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "urgenttype_name",
      text: "ความด่วน",
      sort: true,
      headerStyle: () => GetHeaderStyle("120px", null, "niramit", "18px"),
      style: () =>
        getCellStyle(
          "center",
          null,
          fontSize,
          fontName,
          "1px solid var(--date-border)"
        ),
      formatter: UrgentType,
      filter: textFilter(customTextFilter),
    },

    {
      dataField: "test",
      text: "ไฟล์",
      style: getCellStyle(
        "center",
        null,
        fontSize,
        fontName,
        "1px solid var(--date-border)"
      ),
      headerStyle: () => GetHeaderStyle("80px"),
      formatter: (x, row) => DicomStatusHeader(x, row),
    },
    {
      dataField: "action_event",
      text: "สถานะ",
      headerStyle: () => GetHeaderStyle("120px"),
      style: getCellStyle("left", null, fontSize, fontName),
      formatter: formatStatus,
      align: "center",
    },
  ];
  return cols;
};
